@if (formData) {
  <h5
    class="mobi-ui-card-fullwidth mobi-ui-font-h6 mobi-ui-padding-t-md mobi-ui-font-medium mobi-ui-padding-b-none"
  >
    <div class="flex items-center">
      <mobi-ui-icon-major class="mobi-ui-text-inked pl-0 mr-[10px]" name="shield_cover" />
      {{
        'calc_selection'
          | texts
            : {
                context: 'primcalc',
                default: 'Leistungswahl',
              }
      }}
    </div>
  </h5>
  <div class="mobi-ui-separator-minor !m-0"></div>
  <ul class="mobi-ui-list-silent is-block mobi-ui-font-size-50">
    <li>
      <div class="mobi-ui-font-size-100">
        <mobi-ui-icon-major class="mobi-ui-text-inked !m-0 pl-0" name="tik_checkbox" />
        <span class="ml-[10px]">{{
          'cyber_benefit_1'
            | texts
              : {
                  context: 'primcalc',
                  default: 'Datenverlust',
                }
        }}</span>
      </div>
    </li>
    <li>
      <div class="mobi-ui-font-size-100">
        <mobi-ui-icon-major class="mobi-ui-text-inked !m-0 pl-0" name="tik_checkbox" />
        <span class="ml-[10px]">{{
          'cyber_benefit_2'
            | texts
              : {
                  context: 'primcalc',
                  default: 'Cyber-Rechtsschutz',
                }
        }}</span>
      </div>
    </li>
    <li>
      <div class="mobi-ui-font-size-100">
        <mobi-ui-icon-major class="mobi-ui-text-inked !m-0 pl-0" name="tik_checkbox" />
        <span class="ml-[10px]">{{
          'cyber_benefit_3'
            | texts
              : {
                  context: 'primcalc',
                  default: 'Vermögensschäden',
                }
        }}</span>
      </div>
    </li>
  </ul>
  <div
    class="mobi-ui-card-fullwidth mobi-ui-list-silent is-description-list mobi-ui-margin-t-sm mobi-ui-font-size-50"
  >
    <mobi-ui-icon-major class="mobi-ui-text-inked pl-0 mr-[15px]" name="purse" />
    <div class="mt-5">
      <div class="mobi-ui-font-h6 mobi-ui-font-medium">
        {{
          'contract_duration'
            | texts: { context: 'primcalc', default: 'Vertragslaufzeit' }
        }}
      </div>
      <div class="mobi-ui-font-size-100">
        @if (formData[formId + '--ins_start'] === 'today') {
          <span> {{ today }}&nbsp;-&nbsp;{{ contractEnd }} </span>
        } @else {
          {{ contractStart }}&nbsp;-&nbsp;{{ contractEnd }}
        }
      </div>
    </div>
  </div>
  <div
    class="mobi-ui-card-fullwidth mobi-ui-list-silent is-description-list mobi-ui-margin-t-xxs mobi-ui-font-size-50"
  >
    <mobi-ui-icon-major class="mobi-ui-text-inked pl-0 mr-[15px]" name="purse" />
    <div class="mt-5">
      <div class="mobi-ui-font-h6 mobi-ui-font-medium">
        {{ 'deductible' | texts: { context: 'primcalc', default: 'Selbstbehalt' } }}
      </div>
      <div class="mobi-ui-font-size-100">CHF&nbsp;0.00</div>
    </div>
  </div>
  <div class="mobi-ui-text-center mobi-ui-padding-b-md mobi-ui-margin-t-lg">
    <span class="mobi-ui-font-h6 mobi-ui-font-medium">
      {{ 'annual_premium' | texts: { context: 'primcalc', default: 'Jahresprämie' } }}
    </span>
    <div class="mobi-ui-price-major is-center mb-2 lg:mb-0">
      <span class="mobi-ui-price-unit-major">CHF</span>
      <span class="mobi-ui-price-value-major premium-value">{{
        formatNumber(result.annual_premium, '0,0.00')
      }}</span>
    </div>
  </div>
}
